import {Celebration, EmojiFoodBeverage, Google} from "@mui/icons-material";
import {Alert, AlertTitle, Fab, Slide, Snackbar} from "@mui/material";
import {useEffect, useState} from "react";
import {red_900} from "../js/APXTheme.js";
import {getExtraMessage, getMessageFromDev, getPlusAppLink, getPlusMessage} from "./APXPlus.js";


export function APXPlusStatusAlert({isPlus}: { isPlus: boolean | undefined }) {
	  const [show, setShow] = useState(false);
	  useEffect(() => {
			 if (isPlus !== undefined) {
					setShow(true);
					setTimeout(() => setShow(false), isPlus ? 750 : 3000);
			 }
	  }, [isPlus]);
	  
	  return (
				 <>
						{isPlus !== undefined &&
								  <>
										 <Snackbar
													open={show}
													anchorOrigin={{vertical: "bottom", horizontal: "center"}}
													TransitionComponent={Slide}
										 >
												<Alert
														  icon={isPlus ? <Celebration fontSize={"inherit"}/> : <EmojiFoodBeverage fontSize={"inherit"}/>}
														  severity="error" variant={"filled"}
														  sx={{m: 2, alignItems: "center", justifyContent: "center", color: "#000", backgroundColor: red_900}}
														  action={
																 /*NOT->*/ !isPlus &&
																	 <Fab size="small"
																			sx={{opacity: 0.85}}
																			onClick={() => {
																				  window.open(
																							 getPlusAppLink(),
																							 "_blank",
																							 "noopener,noreferrer"
																				  );
																			}}>
																			<Google/>
																	 </Fab>
														  }
												>
													  {/*NOT->*/ !isPlus && <AlertTitle color={"rgba(255,255,255,0.85)"}>{getMessageFromDev()}</AlertTitle>}
													  {getPlusMessage(isPlus)}
												</Alert>
										 </Snackbar>
								  </>
						}
				 </>
	  );
}


export function APXPlusRequiredAlert() {
	  const [open, setOpen] = useState(true);
	  return (
				 <>
						<Snackbar
								  open={open}
								  onClose={() => setOpen(false)}
								  autoHideDuration={5000}
								  anchorOrigin={{vertical: "bottom", horizontal: "center"}}
								  TransitionComponent={Slide}
						>
							  <Alert
										 icon={<EmojiFoodBeverage fontSize={"inherit"}/>}
										 severity="error" variant={"filled"}
										 sx={{m: 2, alignItems: "center", justifyContent: "center", color: "#000", backgroundColor: red_900}}
										 action={
												<Fab size="small"
													  sx={{opacity: 0.85}}
													  onClick={() => {
															 window.open(
																		getPlusAppLink(),
																		"_blank",
																		"noopener,noreferrer"
															 );
													  }}>
													  <Google/>
												</Fab>
										 }
							  >
									 <AlertTitle color={"rgba(255,255,255,0.85)"}>{getMessageFromDev()}</AlertTitle>
									 {getExtraMessage()}<br/>
									 {getPlusMessage(false)}
							  </Alert>
						</Snackbar>
				 </>
	  );
}